export const translationLivechat_sv_availability = {
  livechatChangeAvailability: "Tillgänglighet:",
  livechatGoOnline: "Gå online",
  livechatGoOffline: "Gå offline",
  livechatUseSchedule: "Använd schema",
  livechatAvailabilityDisabledHelp:
    "Chatbotar inaktiverade av en administratör förblir oförändrade.",
  livechatAvailabilityUpdated: "Tillgängligheten uppdaterad för {count} chatbotar i {scope}.",
  livechatAvailabilityUpdatedOne: "Tillgängligheten uppdaterad för {chatbot}.",
  livechatAvailabilityAllOnline: "Alla online",
  livechatAvailabilityAllOffline: "Alla offline",
  livechatAvailabilityMixed: "Blandat · {online} av {total} online",
  livechatAvailabilityUnknown: "Tillgänglighet inte tillgänglig",
};
